import { FC } from 'react';
import { useGetCurrentUserQuery } from '@teachur/http-client';
import { useEnrollmentJourney } from '../../hooks/useEnrollmentJourney';
import { EnrollmentPathCard } from '../EnrollmentPathCard/EnrollmentPathCard';
import { Hero } from '../Hero/Hero';
import { ExploreDegreesCard } from '../ExploreDegreesCard/ExploreDegreesCard';

const HERO_SUBTITLE =
  'Three small decisions are all that stand between you and a clear plan for what comes next.';

export const NonEnrolledStudentView: FC = () => {
  const { data: user } = useGetCurrentUserQuery();
  const { wizardComplete, planSaved } = useEnrollmentJourney();

  return (
    <div className="flex flex-col gap-6">
      <Hero
        title={user?.firstName ? `Welcome, ${user.firstName}!` : 'Welcome!'}
        subtitle={HERO_SUBTITLE}
      />
      <div className="flex flex-col gap-6 xl:flex-row xl:items-stretch">
        <div className="min-w-0 flex-1">
          <EnrollmentPathCard wizardComplete={wizardComplete} planSaved={planSaved} />
        </div>
        <div className="xl:w-[36%] xl:max-w-118 xl:shrink-0">
          <ExploreDegreesCard />
        </div>
      </div>
    </div>
  );
};
